export const FINISH_LATER_REQUEST = 'FINISH_LATER_REQUEST';
export const FINISH_LATER_SUCCESS = 'FINISH_LATER_SUCCESS';
export const FINISH_LATER_FAILURE = 'FINISH_LATER_FAILURE';
export const FINISH_LATER_RESET = 'FINISH_LATER_RESET';
// Fetch data actions
export const finishLaterRequest = () => ({
    type: FINISH_LATER_REQUEST,
});
export const finishLaterSuccess = (payload) => ({
    type: FINISH_LATER_SUCCESS,
    payload,
});
export const finishLaterFailure = (error) => ({
    type: FINISH_LATER_FAILURE,
    payload: error,
});
export const finishLaterReset = () => ({
    type: FINISH_LATER_RESET,
});
